import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { headerHeight, HeaderLink } from '@this/components/expenses/header/header';
import { ItemIcon, ReportIcon, ApprovalIcon, SettingIcon } from './header_icons';
import type User from '../../../domain/user/user';
import { styled } from '../../constants/themes';

interface Props {
  user: User;
  className?: string;
}

const NavContentSm: React.FC<Props> = ({ user, className }) => {
  const location = useLocation();
  const path = location.pathname;

  return (
    <Nav className={className}>
      <HeaderLink>
        <Link to="/aiexpense/report_items">
          <ItemIcon isActive={path.startsWith('/aiexpense/report_items')} />
          <span className={path.startsWith('/aiexpense/report_items') ? 'active' : ''}>登録</span>
        </Link>
      </HeaderLink>
      <HeaderLink>
        <Link to="/aiexpense/reports">
          <ReportIcon isActive={path.startsWith('/aiexpense/reports')} />
          <span className={path.startsWith('/aiexpense/reports') ? 'active' : ''}>申請</span>
        </Link>
      </HeaderLink>
      {(user?.isOrganizationAdmin || user?.is_expenses_approver) && (
        <HeaderLink>
          <Link to="/aiexpense/approvals">
            <ApprovalIcon isActive={path.startsWith('/aiexpense/approvals')} />
            <span className={path.startsWith('/aiexpense/approvals') ? 'active' : ''}>承認</span>
          </Link>
        </HeaderLink>
      )}
      {user?.isOrganizationAdmin && (
        <HeaderLink>
          <Link to="/aiexpense/organization">
            <SettingIcon isActive={path.startsWith('/aiexpense/organization')} />
            <span className={path.startsWith('/aiexpense/organization') ? 'active' : ''}>管理</span>
          </Link>
        </HeaderLink>
      )}
    </Nav>
  );
};

const Nav = styled.nav`
  position: fixed;
  top: ${headerHeight};
  left: 0;
  right: 0;
  background-color: #393e46;
  z-index: 1000;
`;

export default NavContentSm;
